import { useState } from "react";

type Notification = {
    id: number;
    message: string;
};

const delay = (ms: number) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

export const useNotifications = () => {
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [counter, setCounter] = useState(0);

    const addItem = (message: string) => {
        const newId = counter;
        setNotifications((prev) => [...prev, { id: newId, message }]);
        setCounter((c) => c + 1);

        (async () => {
            await delay(6000);
            removeItem(newId);
        })();
    };

    const removeItem = (id: number) => {
        setNotifications((prev) => prev.filter((n) => n.id !== id));
    };

    return { notifications, addItem, removeItem };
};
